import { render, staticRenderFns } from "./gImg2.vue?vue&type=template&id=0ae73050&scoped=true&"
import script from "./gImg2.vue?vue&type=script&lang=js&"
export * from "./gImg2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae73050",
  null
  
)

export default component.exports